import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// inject token if present
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wazi_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && !path.endsWith("/login")) {
        localStorage.removeItem("wazi_token");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
